import React from 'react';
import Component from '../../components/Component';
import Datagrid from '../../components/Datagrid';
import Renderers from '../../helpers/Renderers';
import DbInfo from '../../dbinfo';
import c from '../../constants';
import {FormManager} from 'reactis-forms';
import {FilterInput, Select, SearchInput, AbcdInput} from 'reactis-inputs';
import {FilterResetButton, FilterField} from 'reactis-datagrid';
import {Button, ButtonToolbar} from 'react-bootstrap';
import {AlertWindow} from 'reactis-modal';
import EventEmitter from '../../EventEmitter';
import DateRange from '../../components/Form/DateRange';
import DocumentTitle from 'react-document-title';
import {connect} from 'react-redux';
import ActiveSelect from '../../components/Form/ActiveSelect';
import {bindActionCreators} from 'redux';
import NavBar from '../../components/NavBar';
import store from 'store2';


export default class List extends Component {

	constructor(props, context) {
		super(props);

		const rendererLink = (val, row) => {
			return <a href={'/emailaccount/'+row.id} onClick={(e) => this.handleOpen(row, e)}>{val}</a>;
		};

		this.columnModel = [
			{
				name: 'email',
				title: 'E-mail',
				field: 'email',
				renderer: rendererLink
			},
			{
				name: 'name',
				title: 'Jméno',
				field: 'name'
			},
			{
				name: 'edit',
				title: 'Akce',
				field: 'id',
				style: {whiteSpace: 'nowrap'},
				width: 30,
				align: 'center',
				sortable: false,
				renderer: (val, row) => {
					return (
						<a href={'/emailaccount/'+val} onClick={(e) => this.handleOpen(row, e)}>
							<i className="fa fa-pencil position-left"></i><span className="vp-desktop">Upravit</span>
						</a>
					);
				}
			}
		];

		const filterSchema = {
			id: { class: FilterInput },
			published: { class: DateRange },
			cTitle: { class: FilterInput },
			pTitle: { class: FilterInput },
			text: { class: FilterInput },
			fulltext: { class: SearchInput },
			edit: {
				class: FilterResetButton,
				visible: () => this.filter.isChanged(),
				onClick: () => this.filter.reset()
			}
		};
		this.filter = new FormManager(filterSchema);
		const sessionState = store.session.get('dg-emailaccount');
		// default
		let filter = {};
		// session
		if (sessionState && sessionState.filter) {
			filter = sessionState.filter;
		}
		this.defaultFilter = filter;
		this.defaultSort = sessionState && sessionState.sort ? sessionState.sort : {column: 'published', 'direction': 'desc'};
	}

	componentDidMount() {
		this.changeListener = () => {
			this.refs.datagrid.getWrappedInstance().refresh();
		};
		EventEmitter.on('emailaccount.change', this.changeListener);
	}

	componentWillUnmount() {
		EventEmitter.removeListener('emailaccount.change', this.changeListener);
	}

	handleOpen(row, e) {
		e.preventDefault();
		this.props.actions.openTabForm('emailaccount', '#' + row.id, row);
	}

	handleNewClick(e) {
		e.preventDefault();
		this.props.newTab();
	}

	render() {

		const buttons = <Button href="/emailaccount/0" onClick={(e) => this.handleNewClick(e)}>
			<i className="fa fa-plus position-left"/>Nový účet
		</Button>;


		return (
			<div>
				<NavBar title="E-mailové účty" buttons={[{icon: 'fa fa-refresh', onClick: () => this.refs.datagrid.getWrappedInstance().refresh()},{icon: 'fa fa-plus', onClick: () => this.props.newTab()}]} />
				<Datagrid
					ref="datagrid"
					id="emailaccount"
					api="emailaccount.getList"
					buttons={buttons}
					filters={['fulltext']}
					filter={this.filter}
					saveState={true}
					getRowClassName={null}
					columnModel={this.columnModel}
					defaultFilter={this.defaultFilter}
					defaultSort={this.defaultSort}
				/>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Emailaccount/List.js